import React, {useState} from 'react';
import {Link} from "react-router-dom";
import DynamicWebServiceDrivenForm from "../../platform/webform/DynamicWebServiceDrivenForm";
import {Card} from "../../components/Card";
import {createInternationalizationPrefixer, getCurrentLanguage} from "../../platform/i18n/i18n";
import {AuthLanguageSwitcher} from "../account/AuthLanguageSwitcher";
import "../account/auth-forms.css";

const t = createInternationalizationPrefixer("RegisterUserPage");

const FORM = "form";
const SUCCESS = "success";

export function RegisterUserPage() {
    const [viewState, setViewState] = useState<string>(FORM);

    const bodyContent = viewState === FORM
        ? <RegistrationForm onSuccess={() => setViewState(SUCCESS)}/>
        : <RegistrationSuccessMessage/>;

    return <div>
        <div className="account-pages mt-5 mb-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6 col-xl-5">
                        <AuthLanguageSwitcher/>
                        <Card>
                            <RegistrationHeader/>
                            {bodyContent}
                        </Card>
                    </div>
                </div>
            </div>
        </div>
        <footer className="footer footer-alt text-dark text-center">
            {(new Date().getFullYear())} &copy; Wentech
        </footer>
    </div>;
}

function RegistrationHeader() {
    return <div className="text-center">
        <div className="clearfix text-center pt-20 pb-20">
            <img src="/img/wentech_logo.svg" width="60%" alt="logo"/>
            <div className="text-muted mt-3">
                <h3>Optisel 2</h3>
                {t("Rejestracja nowego konta")}
            </div>
        </div>
    </div>;
}

function RegistrationForm({onSuccess}: { onSuccess: () => void }) {
    return <div className="auth-wide-form">
        <DynamicWebServiceDrivenForm
            dslUrl="/api/registration/form"
            submissionUrl="/api/registration/submit"
            submitLabel={t("Zarejestruj się")}
            valueSubmissionPreprocessor={(body: any) => ({...body, language: getCurrentLanguage()})}
            successHandler={onSuccess}/>
        <p className="text-muted small mt-3 mb-0">
            {t("Poza potwierdzeniem adresu e-mail linkiem aktywacyjnym, Twoje konto musi jeszcze zostać aktywowane przez pracownika Wentech.")}
        </p>
        <div className="text-center mt-3">
            <Link to="/sign-in" className="btn btn-link">{t("Powrót do logowania")}</Link>
        </div>
    </div>;
}

function RegistrationSuccessMessage() {
    return <div className="text-center">
        <h4>{t("Dziękujemy")}</h4>
        <p className="mt-3">
            {t("Na podany adres e-mail wysłaliśmy wiadomość z linkiem potwierdzającym. Potwierdź swój adres e-mail, klikając w ten link.")}
        </p>
        <p className="mt-3">
            {t("Po potwierdzeniu adresu e-mail Twoje konto musi jeszcze zostać zaakceptowane i aktywowane przez administratora.")}
        </p>
        <Link to="/sign-in" className="btn btn-link mt-2">{t("Powrót do logowania")}</Link>
    </div>;
}
